import React from 'react';
import PropTypes from 'prop-types';

const DropdownQuestion = ({ question, value, onChange, error }) => {
  const options = question.options || [];

  return (
    <select
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      className={`form-control form-control-sm${error ? ' is-invalid' : ''}`}
    >
      <option value="">Please select...</option>
      {options.map((option, index) => (
        <option key={index} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
};

DropdownQuestion.propTypes = {
  question: PropTypes.object.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string
};

export default DropdownQuestion;